<template>
    <div>
        <div class="card shadow bg-white">
            <div class="card-header h6">
                Boutons de commande
            </div>

            <div class="p-3">
                <div v-if="!buttons || !buttons.length" class="text-muted fst-italic">
                    Aucun bouton configuré pour cette balise.
                </div>

                <div v-else class="d-flex flex-wrap gap-2">
                    <button
                        v-for="button in buttons"
                        :key="button.id || button.buttonIndex"
                        type="button"
                        class="btn btn-sm"
                        :class="[
                            'btn-outline-primary',
                            { 'disabled': !button.baliseCmdRegistered || isSending }
                        ]"
                        @click="sendButton(button)"
                    >
                        {{ getLabel(button) }}
                    </button>
                </div>

                <p v-if="feedbackMessage" class="mt-3 mb-0 small text-center"
                   :class="{'text-success': feedbackSuccess, 'text-danger': !feedbackSuccess}">
                    {{ feedbackMessage }}
                </p>
            </div>

            <div class="card-footer p-3 text-center">
                Uniquement visible aux admin Argos
            </div>
        </div>
    </div>
</template>

<script>
import CmdService from '@/services/cmd.service'

export default {
    props: {
        balise: {
            type: Object,
            required: true
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isSending: false,
            feedbackMessage: '',
            feedbackSuccess: true
        }
    },
    methods: {
        getLabel(button) {
            if (button.label) return button.label
            if (button.baliseCmdRegistered) {
                return button.baliseCmdRegistered.name || button.baliseCmdRegistered.cmd
            }
            return `Bouton ${button.buttonIndex}`
        },
        async sendButton(button) {
            if (!button.baliseCmdRegistered || this.isSending) return

            try {
                this.isSending = true
                this.feedbackMessage = ''

                await CmdService.runRegistered(this.balise.id, button.baliseCmdRegisteredId)

                this.feedbackSuccess = true
                this.feedbackMessage = 'Commande envoyée à la balise ✅'

                setTimeout(() => {
                    this.feedbackMessage = ''
                }, 3000)
            } catch (e) {
                console.error(e)
                this.feedbackSuccess = false
                this.feedbackMessage = 'Erreur lors de l’envoi de la commande ❌'

                setTimeout(() => {
                    this.feedbackMessage = ''
                }, 3000)
            } finally {
                this.isSending = false
            }
        }
    }
}
</script>
